export default {
  // Search
  batchSn: 'Batch No.',
  batchSnPlaceholder: 'Enter batch no.',
  qrcode: 'QR Code',
  qrcodePlaceholder: 'Enter QR code',
  // Table columns
  colBatchSn: 'Batch No.',
  colName: 'Batch Name',
  colCodeRange: 'QR Code Range',
  colCodeCount: 'QR Code Count',
  colCodeRemark: 'Batch Description',
  colStatus: 'Status',
  colCreatedAt: 'Created At',
  colUpdatedAt: 'Updated At',
  colRemark: 'Remark',
  colAction: 'Action',
  // Actions
  editRemark: 'Edit Remark',
  // Edit remark modal
  editRemarkTitle: 'Edit Remark',
  remark: 'Remark',
  remarkPlaceholder: 'Enter remark',
  // Empty state
  emptyText: 'No batch data',
};
